import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, commonData } from "@/mixins/index";
export default {
  name: "studentList",
  mixins: [loadMoreList, commonData],
  data: function data() {
    return {
      paramsData: {
        name: ''
      },
      tableData: [],
      total: 0,
      ageGroupList: [],
      isTeamList: [{
        label: '是',
        value: 1
      }, {
        label: '否',
        value: 2
      }]
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _arguments = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var page;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                page = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 1;
                _this.paramsData.page = page;

                _this.$api.getStudentsAll(_this.paramsData).then(function (res) {
                  if (res.code == 200) {
                    _this.tableData = res.data.data;
                    _this.total = res.data.total;
                  }
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleExamine: function handleExamine(id, type) {
      var _this2 = this;

      var state = '';

      if (type == 'pass') {
        state = 1;
      } else {
        state = 2;
      }

      this.$confirm("\u6B64\u64CD\u4F5C\u5C06".concat(type == 'pass' ? '通过' : '不通过', "\u5B66\u751F, \u662F\u5426\u7EE7\u7EED?"), "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$api.auditStudent({
                  id: id,
                  state: state
                }).then(function (res) {
                  if (res.code == 200) {
                    _this2.$message.success("操作成功!");

                    _this2.getList(_this2.paramsData.page);
                  } else {
                    _this2.$message.error(res.msg);
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    },
    handleDelete: function handleDelete(id) {
      var _this3 = this;

      this.$confirm("此操作将删除该场地, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.$api.delVenues({
                  id: id
                }).then(function (res) {
                  if (res.code == 200) {
                    _this3.$message.success("删除成功!");

                    _this3.getList(_this3.paramsData.page);
                  } else {
                    _this3.$message.error(res.msg);
                  }
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    }
  }
};